import { useQuery } from '@tanstack/react-query';
import { useHasRole } from '@/hooks/useSession';
import { getTransmitterOptions } from '../api';
import { transmittersKeys } from './useTransmitters';

/**
 * Reload dropdown options when organisation changes.
 * Admin-only: non-admin users cannot change organisation.
 */
export function useTransmitterOptions(
  orgId: string | null,
  deviceType: 'transmitters' | 'gateways' = 'transmitters',
) {
  const isAdmin = useHasRole('full_admin');

  return useQuery({
    queryKey: [...transmittersKeys.options(orgId ?? undefined), deviceType],
    queryFn: () => getTransmitterOptions(orgId!, isAdmin, deviceType),
    enabled: !!orgId && isAdmin,
    staleTime: 0,
    gcTime: 0, // No caching — org change must always fetch fresh options
  });
}
